<template>

<div :style="'background-color:'+((page.BackgroundColor==undefined||page.BackgroundColor=='')?'#fff':page.BackgroundColor)">
    <div :style="'height:'+topheight+'px'" ></div>
    <van-sticky>
    <div class="msearch" >
        <div class="msearch-mg" @click="gosearch">
            <span>输入关键字搜索</span>
            <van-icon  class="msearch-mg-icon" :size="12" name="search" />
        </div>
    </div>
    </van-sticky>

    <div class="main-conf">
        <imageAd  :carouselList="carouselList"></imageAd>
    <van-notice-bar
    v-if="Notices.length"
  left-icon="volume-o"
  :text="Notices[0].content"
/>
        <div   :class="isRadius?'catecc setradis m-t':'catecc'" v-if="Navlist.length>0"  >
				<van-swipe :class="isRadius?lastwidth+' bord':lastwidth" :show-indicators="false" @change="changeswipe"> 
				 		<van-swipe-item v-for="(group,gindex) in Navlist" :key="gindex">
							
							<div  class="cate-section" >
								<div v-for="(item, index) in group.navList" :class="isRadius?lastclass+' setcate-item':lastclass" :key="index"  @click="navurl(item.linkPath)">
									<img :src="$baseurl+item.picPath" />
									<div>{{item.navName}}</div>
								</div>
							</div>
							
				 		</van-swipe-item>
				 </van-swipe>
				 
				 <div class="cateswdot" >
					 <div class="cateswdotnums"  v-for="(group,gindex) in Navlist" :key="gindex">
						 <div :class="swipercate==gindex?'catenum catenumactive':'catenum'">
							 
						 </div>
					 </div>
				 </div>
				 
			</div>

        <div>
              <myhead ref="headnav"  :HeadNavDtoList="HeadNavDtoList" @setnavindex="setnavindex"> </myhead>
        </div>
        <div class="cont-list" v-if="goodlist.length>0">
            <div class="cont-list-tit">商品列表</div>
            <van-pull-refresh  @refresh="onRefresh">
                <div class="cont-list-goods" v-for="(item,index) in goodlist" @click="navtodetail(item)" :key="index">
                    <div class="cont-list-goods-pic" >
                        <img  v-lazy="$baseurl+item.productImageUrl">
                    </div>
                    <div class="cont-list-goods-info">
                        <div class="setmar cont-list-goods-info-name">
                            {{item.pName}}
                        </div>
                        <div class="setmar cont-list-goods-info-price">
                            ￥<span class="cont-list-goods-info-price-wz">{{item.price}}</span>
                        </div>
                        <div class="setmar cont-list-goods-info-gz">
                            规格可选{{item.skus.length}}
                        </div>
                    </div>
                
                    <div class="cont-list-goods-btns">
                        <van-icon name="cart-circle-o" size="38"  color="#f9da33"/>
                    </div>
                </div>
            </van-pull-refresh>
        </div>
        <div style="height:50px">

        </div>
    </div>


    <!-- <div v-for="(item,index) in page.Sections" :key="index">
        <imageAd v-if="item.Code=='ImageAd'" :data="item.ParameterDictionary"></imageAd>
        
        <imageText v-if="item.Code=='ImageText'" :data="item.ParameterDictionary"></imageText>

        <pageLine v-if="item.Code=='Line'"  :data="item.ParameterDictionary" ></pageLine>

        <whitespace v-if="item.Code=='Line'" :data="item.ParameterDictionary"  />

        <pageText v-if="item.Code=='Text'" :data="item.ParameterDictionary" ></pageText>

        <notice v-if="item.Code=='Notice'" :data="item.ParameterDictionary" ></notice>

        <search v-if="item.Code=='Search'" :data="item.ParameterDictionary" v-on:settopheight="settopheight($event)" ></search>

        <pageTitle v-if="item.Code=='Title'" :data="item.ParameterDictionary" ></pageTitle>

        <cube v-if="item.Code=='Cube'" :data="item.ParameterDictionary" ></cube> 
        
       

        <product v-if="item.Code=='Product'" :data="item" ></product>
    </div> -->
<navigate />
</div>
</template>
<script>
import "../../assets/style/index.css";
import whitespace from "../../components/page/whitespace.vue";
import pageLine from "../../components/page/line.vue";
import pageText from "../../components/page/text.vue";
import notice from "../../components/page/notice.vue";
import search from "../../components/page/search.vue";
import pageTitle from "../../components/page/title.vue";
import cube from "../../components/page/cube.vue";
import imageAd from "../../components/page/imageAd.vue";
import imageText from "../../components/page/imageText.vue";
import product from "../../components/page/product.vue";
import request from "../../config/ajax";
//import appconst from "../../config/appconst";

export default {
    name:"page",
    components:{
        whitespace,
        pageLine,
        pageText,
        notice,
        search,
        pageTitle,
        cube,
        [imageAd.name]:imageAd,
        imageText,
        product
    },
    data:function(){
        return{
            isLoading:false,
            topheight:0,
            page:{
                // BackgroundColor:"#f9da33"
            },
            carouselList:[],
            goodreq:
            {
                maxResultCount: 10,
                skipCount: 0,
                loaded:false,
                loadingType:''
            },
            goodlist:[],
            searchdata:{
                position:'fixed',
                textalign:'center'
            },
            HeadNavDtoList:[],
            fcurHeadNavDtoList:[],
            PhoneHeadNavInput:{
                "sorting": " sorter desc",
                "maxResultCount": 6,
                "skipCount": 0,
            },
            lastclass:'cate-item',
			lastwidth:'catesw catebj',
            isRadius:false,
            NavQueryInput:{
                "sorting": " sorter desc",
                "maxResultCount": 6,
                "skipCount": 0,
            },
            Navlist:[],
            swipercate: 0,
            Notices:[],
            scroll:0
        }
    },
    created:function(){
        //拉取轮播图
        // this.getCarouseList();
      this.getgoodlist();
        // // GetPage().then(response=>{
        // //     console.log("数据",response);
        // //     this.page=response;
        // // });
        // this.loadnavdata();
        // this.getnvalist();
        //  this.ajax.post('/api/services/app/PhoneCom/QueryNotice',{maxResultCount:1,skipCount:1}).then(x => {
        //         this.Notices = x.result.items;

        //     })
        this.queryinitdata();
        setTimeout(()=>{
        this.initWx();
      },200)
       window.addEventListener('scroll',this.handleScroll,true)
      
    },
    beforeRouteLeave(to, form, next){
      this.scroll=document.documentElement.scrollTop
      console.log(this.scroll)
      next();
  },
destroyed() {
   window.removeEventListener('scroll', this.handleScroll) //页面离开后销毁监听事件
},
  activated() {
	 document.documentElement.scrollTop=this.scroll
},
    methods:{
        handleScroll(e){
        let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
       let clientHeight = document.documentElement.clientHeight;
       let scrollHeight = document.documentElement.scrollHeight;
       if (scrollTop + clientHeight >= scrollHeight-100) {
             this.getgoodlist();
       }
 
      },
         getgoodlist(source)
    {
        if (this.goodreq.loadingType === 'loading' || this.goodreq.loadingType === 'nomore') {
            //防止重复加载
            if(source != 'refresh')
            {
                return;
            } 
        }
        
        if (source == 'refresh') {
            this.goodlist = [];
            this.goodreq.skipCount = 0;
        }
        this.goodreq.loadingType = 'loading';
        //加载数据
        this.ajax.post('/api/services/app/PhoneCom/QueryProductList', this.goodreq).then(x => {
            this.goodreq.skipCount += this.goodreq.maxResultCount;
            let totalcount = x.result.totalCount;
            this.goodlist = this.goodlist.concat(x.result.items);
         
            this.goodreq.loadingType = totalcount > (this.goodreq.skipCount) ? 'more' :'nomore';
        }).finally(()=>
        {
                this.goodreq.loaded=false;
                this.refreshing=false;
        });
    },
        queryinitdata()
        {
            
            this.ajax.post('/api/services/app/PhoneCom/QueryFirstPage').then(x=>
            {
                var fgmodel=x.result;
                this.Navlist = fgmodel.navlist;
                if (this.Navlist.length > 0) {
                    this.setclass(this.Navlist[0].navList.length);
                }
                this.HeadNavDtoList=fgmodel.headNavList;
                for(var z=0;z<this.HeadNavDtoList.length;z++)
                {
                    this.setnavindex(this.HeadNavDtoList[z].headNavDetailList[0],z)
                }
                this.carouselList= fgmodel.carouselList.items;
                this.Notices = fgmodel.noticeList.items;
            });
        },
        changeswipe(index){
            this.swipercate=index;
        },
        setclass(count) {

            if(count!=5&&count<9)
            {
                this.lastclass='cate-item cate-item1';
            }
            else
            {
                this.lastclass='cate-item';
            }
            if(count>5)
            {
                this.lastwidth='catesw catebj'
            }
            else
            {
                this.lastwidth='catesw1 catebj'
            }

        },
        setnavindex(item,index){

            this.HeadNavDtoList[index].headNavDetailList.forEach(x => {
                 if(x.id!=item.id)
                 {
                      this.$set(x,"checked",false)
                 }
                 else
                 {
                      this.$set(x,"checked",true)
                 }
            });
            console.log("打印数据",this.HeadNavDtoList);
        },
        settopheight:function(value){
            this.topheight=value;
        },
        onRefresh()
        {
            console.log('999')
            this.getgoodlist();
        },
        navtodetail(item)
        {
            //console.log(this.$router);
            var productsku=item.productSku;
            this.$router.push({path:'/product/'+productsku});
        },
        gosearch()
        {
            this.$router.push({path:'/search'});
        },
        navurl(url){
            this.$router.push({
                path:url
            })
        },
         initWx() {
      //微信配置初始化
      var isIOS = !!window.navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
      let tmpurl = location.href;
      if (isIOS) {
        tmpurl = window.entryUrl;
      } else {
        tmpurl = window.location.href;
      }
      this.ajax
        .post("/api/services/app/PhoneCom/QueryH5Sign", { url: tmpurl })
        .then((y) => {
          var h5info = y.result;
          var wx = window.wx;
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: h5info.appid, // 必填，公众号的唯一标识
            timestamp: h5info.timeStamp + "", // 必填，生成签名的时间戳
            nonceStr: h5info.nonceStr, // 必填，生成签名的随机串
            signature: h5info.sign, // 必填，签名
            jsApiList: [
              "updateAppMessageShareData",
              "updateTimelineShareData",
              "onMenuShareWeibo",
              "scanQRCode",
            ], // 必填，需要使用的JS接口列表
          });
           let link =
            "http://" +
            location.host ;
wx.ready(() => {
            wx.updateAppMessageShareData({
              title: this.abp.systemconfig.shareTitle, // 分享标题
              desc: this.abp.systemconfig.shareDesc, // 分享描述
              link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: this.$baseurl + this.abp.systemconfig.shareImg, // 分享图标
              success: function (res) {
                // 设置成功
              },
              fail: function (res) {
                 //alert(res);
              },
            });
            wx.updateTimelineShareData({
              title: this.abp.systemconfig.shareTitle, // 分享标题
              link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: this.$baseurl + this.abp.systemconfig.shareImg, // 分享图标
              success: function (res) {
                // 设置成功
              },
              fail: function (res) {
                 //alert(res);
              },
            });
          });
          wx.error(function (res) {
            //alert(res);
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
          });
        });
    }
    }
}
</script>

<style lang="scss" scoped>
  .msearch
  {
    padding: 10px 20px;
    background-color: #FFFFFF;
  }
  .msearch-mg
  {
    border-radius: 40px;
    background-color: #e8e8e8;
    position: relative;
    height: 30px;
    padding-left: 100px;
  }
  .msearch-mg-icon
  {
      position: absolute;
      top: 50%;
      transform: translate(0,-50%);
      left: 84px;
  }
  .msearch-mg span{
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    font-size: 12px;
  }
  .search-mg{
      padding-left: 130px;
  }
 .cont-list
 {
     background-color: #fff;
     font-size: 14px;
     padding: 10px;
     color:#86751b;
 }
 .cont-list-tit
 {
    margin-bottom:10px;
    font-weight: bold;
 }
 .cont-list-goods
 {
     position: relative;
 }
 .cont-list-goods-pic
 {
     position: absolute;
     left: 0;
     width: 100px;
     height: 100px;
 }
 .cont-list-goods-pic img
 {
     width: 100%;
     height: 100%;
     border-radius: 4px;
 }
 .cont-list-goods-info
 {
     padding-left: 115px;
 }
 .cont-list-goods-info-price
 {
     color: red;
     font-weight: bold;
     font-size:13px;
 }
 .cont-list-goods-info-price-wz
 {
     font-size:16px ;
 }
 .cont-list-goods-info-gz
 {
     color: silver;
 }
 .cont-list-goods-btns
 {
     position: absolute;
     right: 10px;
     bottom: 0;
 }
 .setmar
 {
     margin-bottom: 20px;
 }
 .catecc{
        position: relative;
        background-color: #FFFFFF;
    }
    .catebj{
        width: 94%;
        margin: 0 auto;
        padding-top:15px;
    }
    .catesw{
        padding-bottom:15px;
    }
    .catesw1{
        padding-bottom:15px;
    }
    .cateswdot{
        position: absolute;
        left: 0;
        bottom: 0;
        right: 0;
        text-align: center;
    }
    .cateswdotnums{
        display: inline-block;
    }
    .catenum{
        display: inline-block;
        background-color: #EBEEF5;
        width: 10px;
        height: 5px;
    }
    .catenumactive{
        background-color: #4399FC;
    }

/* 分类 */
    .cate-section {
        
        .cate-item {
            font-size: 13px;
            color: #303133;
            display: inline-block;
            width: 20%;
            text-align: center;
            padding-bottom: 10px;
        }
        .cate-item1
        {
            width: 25%;
        }
        
        /* 原图标颜色太深,不想改图了,所以加了透明度 */
        img {
            width: 50px;
            height: 50px;
            margin-top: 5px;
            border-radius: 25%;
        }
        
        .setcate-item
        {
            img
            {
                border-radius: 20px;
            }
        }
    }

</style>
